import React, { useId } from "react";

//MUI
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import Box from "@mui/material/Box";

// Types
import {
  WinFactorQuestionModel,
  WinFactorOptionModel,
} from "../../models/WinProbabilityFactorModel";

type Props = {
  index: number;
  question: WinFactorQuestionModel;
  options: WinFactorOptionModel[];
  value: number | null;
  onChange: (
    factor: "GetFactor" | "GoFactor",
    optionId: number,
    questionId: number
  ) => void;
};

const WinProbabilityFactor = ({
  index,
  question,
  options,
  value,
  onChange,
}: Props) => {
  const radioId = useId();
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    val: string
  ) => {
    onChange(question.questionType, +val, question.questionId);
  };

  return (
    <Box sx={{ display: "block" }}>
      <FormControl sx={{ marginBottom: "1em" }}>
        <FormLabel
          id={radioId}
          style={{ fontWeight: "bold", fontSize: "16px" }}
        >
          {index}. {question.questionName}
        </FormLabel>
        <RadioGroup
          aria-labelledby={radioId}
          name="win-probability-factor"
          value={value}
          onChange={handleChange}
        >
          {options.map((option) => (
            <FormControlLabel
              key={option.optionId}
              value={option.optionId}
              control={<Radio />}
              label={option.optionDetails}
              sx={{
                "& .MuiButtonBase-root.MuiRadio-root": {
                  alignSelf: "start",
                  paddingTop: 0,
                },
              }}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </Box>
  );
};

export default WinProbabilityFactor;
